export const OPEN_MOBILE_MENU = 'OPEN_MOBILE_MENU';
export const CLOSE_MOBILE_MENU = 'CLOSE_MOBILE_MENU';
export const NAVIGATE_FROM_MOBILE_MENU = 'NAVIGATE_FROM_MOBILE_MENU';
export const SET_INITIAL_DATA = 'SET_INITIAL_MOBILE_MENU_DATA';
export const CHANGE_MOBILE_MENU_CATEGORIES = 'CHANGE_MOBILE_MENU_CATEGORIES';
export const SELECT_MOBILE_MENU_HISTORY = 'SELECT_MOBILE_MENU_HISTORY';

const openMenu = () => ({
  type: OPEN_MOBILE_MENU,
});

const closeMenu = () => ({
  type: CLOSE_MOBILE_MENU,
});

const navigateFromMobileMenu = () => ({
  type: NAVIGATE_FROM_MOBILE_MENU,
});

const selectHistory = categoryId => ({
  categoryId,
  type: SELECT_MOBILE_MENU_HISTORY,
});

const setInitialData = categories => ({
  categories,
  type: SET_INITIAL_DATA,
});

const changeCategories = state => ({
  ...state,
  type: CHANGE_MOBILE_MENU_CATEGORIES,
});

export default {
  openMenu,
  closeMenu,
  navigateFromMobileMenu,
  selectHistory,
  setInitialData,
  changeCategories,
};
